module.exports = __webpack_public_path__ + "img/ski_cos6.be5fa789.png";